import React, { useEffect, useState } from "react";
import axios from "axios";
import OrderTakerNavbarAllPAges from "../../Components/OrderTakerNavbarAllPAges";
import Loading from "../../Components/Loading";
import { BiSolidEditAlt } from "react-icons/bi";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import { setDivision } from "../../Redux/Action/division";
import TakeOrder from "./TakeOrder";
import CashPOSPopUp from "./CashPOS";

const BILLSPLITTING = ({ hideNavBar , cashPoToPass }) => {
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [search, setSearch] = useState("");
  const [isloading, setisloading] = useState(false);
  const currentDate = new Date();
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1,
  );
  const localStartOfMonth = new Date(
    startOfMonth.getTime() - startOfMonth.getTimezoneOffset() * 60000,
  );

  const [startdate, setStartdate] = useState(localStartOfMonth.toISOString());
  const [enddate, setEnddate] = useState(currentDate.toISOString());

  const [orderHeaders, setOrderHeaders] = useState([]);
  const [totalAmount, setTotalAmount] = useState("");
  const divisionState = useSelector((state) => state.changeDivision);
  const userState = useSelector((state) => state.changeTheState.user);
  const loggedInEmail = userState?.emailId;
  const loggedInUser = userState?.emailId?.split("@")[0]?.toUpperCase();
  const [status, setStatus] = useState("");
  const dispatch = useDispatch();
  const [showTakeOrder, setShowTakeOrder] = useState(false);
  const [showCashPos, setShowCashPos] = useState(false);
  const [orderNo, setOrderNo] = useState("");

  const [selectedBillItems, setSelectedBillItems] = useState([]);
  const [noOfSubBills, setNoOfSubBills] = useState("");
  const [loadingBillItems, setLoadingBillItems] = useState(false);

  // Total calculations
  // Filters
  const filtOrders = orderHeaders.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);
    // const itemDate = new Date(item.DATETIME);

    const itemDate = item.DATETIME
      ? new Date(item.DATETIME.replace("Z", ""))
      : null;

    const start = startdate ? new Date(startdate) : null;
    const end = enddate ? new Date(enddate) : null;

    if (start) start.setHours(0, 0, 0, 0);
    if (end) end.setHours(23, 59, 59, 999);

    if (searchData.length === 0 && !startdate && !enddate) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "BILLNO",
        "TABLENO",
        "DIVISION",
        "CURRENCY",
        "WAITER",
        "RECEIPTAMOUNT",
        "AMOUNT",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const dateMatch =
      (!start || itemDate >= start) && (!end || itemDate <= end);

    return textMatch && dateMatch;
  });

  useEffect(() => {
    let totalAmounts = 0;

    filtOrders.forEach((item) => {
      totalAmounts += parseFloat(item.AMOUNT);
    });

    setTotalAmount(totalAmounts);
  }, [filtOrders]);

  useEffect(() => {
    getOrderHeaders();
  }, []);

  function getOrderHeaders() {
    setisloading(true);

    axios
      .get(`${BASEURL}/getdivisionRights?OM_USER_ACCOUNT=${loggedInEmail}`)
      .then((response) => {
        dispatch(setDivision(response?.data[0]?.OM_USER_DIVISION || ""));
      })
      .catch((err) => {
        console.log(
          "Error while fetching Division Rights : /getdivisionRights",
          err,
        );
        setisloading(false);
      });
    axios
      .get(
        // `${BASEURL}/getOrderHeaders?DIVISION=${divisionState}&CREATEDBY=${loggedInUser}`,
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=1680&WAITER=${loggedInUser}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        console.log(res.data);
        const sortedData = res?.data?.sort((a, b) => b.BILLNO - a.BILLNO);
        setOrderHeaders(sortedData);
        setisloading(false);
      })
      .catch((err) => {
        console.log("Error while fetching /getOrderHeaders", err);
        setisloading(false);
      });
  }

  // New Data
  const fetchSelectedBillItems = async (billNo) => {
    if (!billNo) return;

    try {
      setLoadingBillItems(true);

      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=622&INVNO=${encodeURIComponent(
          billNo,
        )}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      console.log("Bill 622 Response:", response?.data);

      const data = Array.isArray(response?.data)
        ? response.data
        : response?.data?.data || [];

      const formattedData = data.map((item, index) => ({
        ...item,
        sno: index + 1,

        // Keep this empty initially.
        // User has to select the Sub Bill No manually.
        SUBBILLNO: "",
      }));

      setSelectedBillItems(formattedData);

      // Reset sub-bill selection every time another order is clicked
      setNoOfSubBills("");
    } catch (error) {
      console.error("Error fetching bill items:", error);
      alert("Unable to fetch selected Bill details");
      setSelectedBillItems([]);
    } finally {
      setLoadingBillItems(false);
    }
  };

  const handleSplitBill = async () => {
    if (!selectedBillItems || selectedBillItems.length === 0) {
      alert("No items available to Split Bill");
      return;
    }

    if (!noOfSubBills) {
      alert("Kindly Select No of Sub Bills");
      return;
    }

    // Check every item has a Sub Bill No
    const missingSubBill = selectedBillItems.some((item) => !item?.SUBBILLNO);

    if (missingSubBill) {
      alert("Kindly Specify Sub Bill No for Each Item");
      return;
    }

    // At this point all rows have a sub-bill number
    console.log("Selected Bill:", orderNo);
    console.log("No of Sub Bills:", noOfSubBills);
    console.log("Split Items:", selectedBillItems);

    try {
      // Your SP 1810/other Split Bill SP call goes here

      // Example payload
      const payload = {
        BILLNO: orderNo,
        NOSUBBILLS: Number(noOfSubBills),
        ITEMS: selectedBillItems.map((item) => ({
          ITEMCODE: item?.ITEMCODE,
          QUANTITY: item?.QUANTITY,
          SUBBILLNO: Number(item?.SUBBILLNO),
        })),
      };

      console.log("Split Bill Payload:", payload);

      /*
    const response = await axios.post(
      `${BASEURL_GLOBAL}/globalSpHandler?spname=XXXX`,
      payload,
      getHeaders()
    );

    console.log("Split Bill Response:", response?.data);

    alert("Bill Split Successfully");
    setShowTakeOrder(false);
    */
    } catch (error) {
      console.error("Split Bill Error:", error);
      alert("Unable to Split Bill");
    }
  };


  // When CASHPOS is passed 
  useEffect(() => {
if (cashPoToPass !== undefined && cashPoToPass !== null && cashPoToPass !== "") {
const billNo = String(cashPoToPass).trim();
if (!billNo) return;
console.log("Cash POS Bill No Passed:", billNo);
// Set selected bill
setOrderNo(billNo);
// Open List of Items directly
setShowTakeOrder(true);
// Fetch and populate items for this bill
fetchSelectedBillItems(billNo);

}
}, [cashPoToPass]);


  if (isloading) {
    return <Loading />;
  }

  return (
    <div className="bg-gray-50 min-h-[100vh]">
      {!hideNavBar && divisionState && <OrderTakerNavbarAllPAges />}
      {/* <header
        className="header__of__main"
        style={{ textAlign: "center", margin: "15px 0px" }}
      >
        <h1 className="header__of__page">My List Of Orders</h1>
      </header> */}
      <section className="lg:flex items-center gap-5 mx-5 mt-5">
        <div className="lg:flex items-center gap-3">
          <p>Search:</p>
          <input
            className="w-[300px] h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
            type="text"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />

          <p className="text-red-600 ml-2">Start Date:</p>
          <input
            type="date"
            className="w-36 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            onChange={(e) => {
              setStartdate(e.target.value);
            }}
            value={startdate.split("T")[0]}
          ></input>
          <p className="text-red-600 ml-2">End Date:</p>
          <input
            type="date"
            className="w-36 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
            onChange={(e) => {
              setEnddate(e.target.value);
            }}
            value={enddate.split("T")[0]}
          ></input>
        </div>
      </section>

      <div className="overflow-y-auto h-[300px] px-4">
        {filtOrders.length > 0 ? (
          <>
            <aside className="table__pos__app text-sm ">
              <table class="custom-table">
                <thead class="header-cell">
                  <tr>
                    <td className="text-left">S no</td>
                    <td className="text-left">DIVISION</td>
                    <td className="pl-2">ORDER NO</td>
                    <td className="text-left">TABLE NO</td>
                    <td className="text-left">WAITER</td>
                    <td className="text-left">ORDER TIME</td>
                    <td className="text-right">AMOUNT</td>
                    <td className="text-right">RECEIPT AMOUNT</td>
                    <td className="text-right">CURRENCY</td>
                  </tr>
                </thead>
                <tbody>
                  {filtOrders.map((row, index) => (
                    <tr
                      key={row?.BILLNO}
                      className={
                        index < orderHeaders.length
                          ? "border-b cursor-pointer text-sm table-row"
                          : ""
                      }
                      onClick={() => {
                        setOrderNo(row.BILLNO);
                        setShowTakeOrder(true);
                        fetchSelectedBillItems(row.BILLNO);
                      }}
                    >
                      <td className="text-right">{index + 1}</td>
                      <td className="text-left">{row.DIVISION || ""}</td>
                      <td className="text-right pr-12">
                        {row.BILLNO ? row.BILLNO : ""}
                      </td>
                      <td className="text-left">
                        {row?.TABLENO ? row?.TABLENO : ""}
                      </td>
                      <td className="text-left">
                        {row?.WAITER ? row?.WAITER : ""}
                      </td>
                      <td className="text-left">
                        {row.DATETIME
                          ? moment
                              .utc(row.DATETIME)
                              ?.format("DD-MM-YYYY HH:mm:ss")
                          : ""}
                      </td>
                      <td className="text-right pr-12">
                        {row.AMOUNT
                          ? row.AMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.0"}
                      </td>
                      <td className="text-right pr-12">
                        {row.RECEIPTAMOUNT
                          ? row.RECEIPTAMOUNT.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.0"}
                      </td>
                      <td className="text-left">{row.CURRENCY || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </aside>
            <div className="flex gap-2 ml-48">
              <p className=" text-gray-700">Total Orders :</p>
              <span className="font-extrabold">
                {filtOrders.length > 0 ? filtOrders.length : "0"}
              </span>
              <p>|</p>
              <p className=" text-gray-700">Total Amount :</p>
              <span className="font-extrabold">
                {totalAmount
                  ? totalAmount.toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : "0.0"}
              </span>
            </div>
          </>
        ) : (
          <div className="flex justify-center mt-4">
            <h1 className="font-extrabold text-3xl">No Orders Available</h1>
          </div>
        )}
      </div>

      {showTakeOrder && (
        <div className="fixed top-[70px] left-1/2 -translate-x-1/2 bg-white border border-black lg:h-[calc(100vh-90px)] h-[calc(100vh-80px)] lg:w-[1000px] w-[95%] p-3 overflow-y-auto z-[500] rounded-md shadow-xl">
          {/* Close Button */}
          <button
            type="button"
            className="absolute top-[15px] right-2 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-4 py-1 focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => {
              setShowTakeOrder(false);
              setSelectedBillItems([]);
              setNoOfSubBills("");
            }}
          >
            Close
          </button>

          {/* Heading */}
          <div className="mt-1 mb-2">
            <h2 className="text-lg font-bold underline">
              List of Items from the Selected Bill
            </h2>
          </div>

          {/* Top Controls */}
          <div className="flex flex-wrap items-center gap-3 mb-3">
            {/* No of Sub Bills */}
            <div className="flex items-center gap-2">
              <label className="font-semibold whitespace-nowrap">
                No of Sub Bills:
              </label>

              <select
                className="border border-black h-8 px-2 rounded-sm"
                value={noOfSubBills}
                onChange={(e) => {
                  const value = e.target.value;

                  setNoOfSubBills(value);

                  // Clear all previously selected sub bill numbers
                  setSelectedBillItems((prev) =>
                    prev.map((item) => ({
                      ...item,
                      SUBBILLNO: "",
                    })),
                  );
                }}
              >
                <option value="">Select</option>

                {Array.from({ length: 9 }, (_, index) => index + 1).map(
                  (number) => (
                    <option key={number} value={number}>
                      {number}
                    </option>
                  ),
                )}
              </select>
            </div>

            {/* Sub Bills */}
            <div className="flex items-center gap-2">
              <label className="font-semibold whitespace-nowrap">
                Sub Bills:
              </label>

              <input
                type="text"
                value={noOfSubBills || ""}
                readOnly
                className="border border-black h-8 w-20 px-2 bg-gray-100 text-center"
              />
            </div>
          </div>

          {/* Selected Bill */}
          <div className="mb-2 font-semibold">
            Selected Bill No:
            <span className="ml-2 font-bold">{orderNo}</span>
          </div>

          {/* Loading */}
          {loadingBillItems ? (
            <div className="flex justify-center items-center py-10">
              <span className="font-semibold">Loading bill items...</span>
            </div>
          ) : (
            <>
              {/* Items Table */}
              <div className="overflow-x-auto">
                <table className="custom-table w-auto text-[10px]">
                  <thead className="header-cell">
                    <tr>
                      <td className="text-center">S No</td>

                      <td className="text-left">Product Code</td>

                      <td className="text-left">Product Name</td>

                      <td className="text-right">Quantity</td>

                      <td className="text-right">Rate (Exclusive)</td>

                      <td className="text-right">VAT Amount</td>

                      <td className="text-right">Levy Amount</td>

                      <td className="text-right">Rate (Inclusive)</td>

                      <td className="text-right">Total Amount</td>

                      <td className="text-center">Sub Bill No</td>
                    </tr>
                  </thead>

                  <tbody>
                    {selectedBillItems.length > 0 ? (
                      selectedBillItems.map((item, index) => (
                        <tr key={index}>
                          {/* S No */}
                          <td className="text-center">{index + 1}</td>

                          {/* Product Code */}
                          <td className="text-left">
                            {item?.["ITEM CODE"] || ""}
                          </td>

                          {/* Product Name */}
                          <td className="text-left">
                            {item?.["ITEM NAME"] || ""}
                          </td>

                          {/* Quantity */}
                          <td className="text-right">
                            {Number(item?.QTY || 0)}
                          </td>

                          {/* Rate Exclusive */}
                          <td className="text-right">
                            {Number(
                              item?.["ITEM VALUE EXC VAT"] || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>

                          {/* VAT */}
                          <td className="text-right">
                            {Number(item?.["VAT AMOUNT"] || 0).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </td>

                          {/* Levy */}
                          <td className="text-right">
                            {Number(item?.["LEVY AMOUNT"] || 0).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </td>

                          {/* Rate Inclusive */}
                          <td className="text-right">
                            {Number(
                              item?.["RATE INCLUSIVE"] || 0,
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>

                          {/* Total Amount */}
                          <td className="text-right">
                            {Number(item?.["ITEM VALUE"] || 0).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              },
                            )}
                          </td>

                          {/* Sub Bill No */}
                          <td className="text-center">
                            <select
                              className="border border-black h-7 px-1 min-w-[70px]"
                              value={item?.SUBBILLNO || ""}
                              disabled={!noOfSubBills}
                              onChange={(e) => {
                                const value = e.target.value;

                                setSelectedBillItems((prev) =>
                                  prev.map((row, rowIndex) =>
                                    rowIndex === index
                                      ? {
                                          ...row,
                                          SUBBILLNO: value,
                                        }
                                      : row,
                                  ),
                                );
                              }}
                            >
                              <option value="">Select</option>

                              {noOfSubBills &&
                                Array.from(
                                  {
                                    length: Number(noOfSubBills),
                                  },
                                  (_, subIndex) => subIndex + 1,
                                ).map((subBillNo) => (
                                  <option key={subBillNo} value={subBillNo}>
                                    {subBillNo}
                                  </option>
                                ))}
                            </select>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={10} className="text-center py-5">
                          No items found for this Bill
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Split Bill Button */}
              <div className="mt-4">
                <button
                  type="button"
                  className="border border-black bg-[#365f9c] text-white px-5 py-2 rounded-sm hover:bg-[#294c7d]"
                  onClick={handleSplitBill}
                >
                  Split Bill
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default BILLSPLITTING;
